import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { GetCompanyDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { Selector, Option } from '../Selects/Selector';

export interface CompanyFromListSelectorProps {
  readOnly?: boolean;
  value?: string;
  companies?: GetCompanyDto[];
  placeholder?: string;
  className?: string;
  onChange?: (option: Option) => void;
}

export default (props: CompanyFromListSelectorProps) => {
  const [displayName, setDisplayName] = useState<string>('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (props.companies) {
      const found = props.companies.find(c => c.id === props.value);
      setDisplayName(found?.name || '');
      setReady(true);
    }
  }, [props.value, props.companies]);

  const provider = async (text: string) => {
    const values = (props.companies || []).filter(c => {
      const name = c.name || '';
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });
    return values.map(c => ({ label: c.name || '', value: c.id }));
  };

  return ready ? (
    <Selector
      uniqueKey={'company-list-' + JSON.stringify(props.value)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={props.placeholder || 'Wskaż firmę...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
    />
  ) : (
    <Skeleton />
  );
};
